import * as React from 'react'
import { TimesheetSettlementPeriodModelParsed } from '@/lib/api/company/configuration/timesheet-basic/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getSettlementTypeName } from '@/app/common/converters/settlementTypeToTextConverter'
import { formatDate } from '@/modules/shared/utils/date'
import { getInclusiveMonthSpan1to4 } from './utils'

type Props = {
  periods: TimesheetSettlementPeriodModelParsed[]
  handleRemove: (period: TimesheetSettlementPeriodModelParsed, index: number) => void
}

export const PeriodsTable = ({ periods, handleRemove }: Props) => {
  const { t } = useLocalize()

  return (
    <div className="tw-w-full">
      <div className="tw-overflow-hidden tw-rounded-xl tw-border tw-border-content-base/10 tw-bg-white tw-shadow-sm">
        <div className="tw-overflow-x-auto">
          <table className="tw-w-full tw-border-separate tw-border-spacing-0">
            <thead className="tw-bg-base-200/60">
              <tr>
                <th className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-base/70">
                  Data od
                </th>
                <th className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-base/70">
                  Data do
                </th>
                <th className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-base/70">
                  Długość
                </th>
                <th className="tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-right tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-base/70">
                  Akcje
                </th>
              </tr>
            </thead>

            <tbody>
              {periods.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    className="tw-px-4 tw-py-10 tw-text-center tw-text-sm tw-text-content-base/60"
                  >
                    Brak okresów do wyświetlenia
                  </td>
                </tr>
              ) : (
                periods.map((p, idx) => {
                  const monthSpan = getInclusiveMonthSpan1to4(
                          new Date(p.periodStartDate), 
                          new Date(p.periodEndDate)
                        )
                  return (
                  <tr
                    key={p.id}
                    className={
                      idx % 2 === 0 ? 'tw-bg-white' : 'tw-bg-base-100/40'
                    }
                  >
                    <td className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-content-base">
                      {formatDate(p.periodStartDate, 'YYYY-MM-DD')}
                    </td>
                    <td className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-content-base">
                      {formatDate(p.periodEndDate, 'YYYY-MM-DD')}
                    </td>
                    <td className="tw-whitespace-nowrap tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-sm tw-text-content-base">
                      <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-secondary/10 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-primary">
                        {monthSpan.ok ? monthSpan.months + ' msc' : getSettlementTypeName(p.settlementType, t)}
                      </span>
                    </td>
                    <td className="tw-border-b tw-border-content-base/10 tw-px-4 tw-py-3 tw-text-right">
                      <button
                        type="button"
                        onClick={() => handleRemove(p, idx)}
                        className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-error/20 tw-bg-error/5 tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-error tw-transition hover:tw-bg-error/10 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-focus-100 focus:tw-ring-offset-2"
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                )
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      <p className="tw-mt-2 tw-text-xs tw-text-content-base/60">
        {periods.length > 0 ? `Liczba okresów: ${periods.length}` : ''}
      </p>
    </div>
  )
}
